import { Flex } from 'antd';
import styled from 'styled-components';
import { RadioStyled } from '../Ant';

export const SortTriggerButton = styled.button`
  width: auto;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  &:disabled {
    cursor: default;
  }
  .icon {
    display: inline-flex;
    font-size: 14px;
    color: var(--clr-general-primary);
    transition: transform 0.2s ease-in-out;
  }
  &.open .icon {
    transform: rotate(180deg);
  }
`;

export const SortRadioGroup = styled(RadioStyled)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  .ant-radio-wrapper {
    width: 100%;
    align-items: center;
    &::after {
      display: none;
    }
    .ant-radio-label {
      width: 100%;
    }
  }
  .sort-option-row {
    width: 100%;
  }
`;

export const SortDirectionOptions = styled(Flex)`
  width: 100%;
  .ant-btn {
    flex: 1 1 0;
    height: 36px;
    font-size: 12px;
    color: var(--clr-subtitle);
    .ant-btn-icon {
      flex-shrink: 0;
      .icon {
        font-size: 20px;
      }
    }
    &.selected {
      border-color: var(--clr-general-primary);
      background-color: var(--selected);
      color: var(--clr-general-primary);
      .icon {
        color: var(--clr-general-primary);
      }
      &:hover {
        background-color: var(--selected-hover);
        border-color: var(--clr-general-primary);
        color: var(--clr-general-primary);
      }
    }
  }
`;

export const SortOption = styled.div`
  width: 100%;
  border: 1px solid var(--clr-border-grey-100);
  border-radius: 5px;
  padding: 15px;
  transition:
    border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
  &:hover {
    border-color: var(--clr-general-border-hover);
    background-color: var(--clr-general-hover);
  }
  &.selected {
    border-color: var(--clr-general-primary);
    background-color: var(--selected);
    &:hover {
      background-color: var(--selected-hover);
    }
  }
`;

export const SortPopoverFooter = styled(Flex)`
  width: 100%;
  .ant-btn {
    height: 36px;
  }
  .ant-btn:first-child {
    width: 100px;
    flex-shrink: 0;
  }
  .ant-btn:last-child {
    flex: 1;
  }
`;
